import React from 'react';

import { LandingPage } from './LandingPage';

const Home = () => {
  return <LandingPage />;
};

export { Home };
